<!-- SPDX-License-Identifier: GPL-3.0-or-later -->
<script lang="ts">
  import Label from '../atoms/Label.svelte';
  import TextInput from '../atoms/TextInput.svelte';

  interface Props {
    label: string;
    value: string;
    placeholder?: string;
    maxlength?: number;
    helper?: string;
    error?: string;
    invalid?: boolean;
    onInput?: (value: string) => void;
    onEnter?: () => void;
  }

  let {
    label,
    value = $bindable(''),
    placeholder,
    maxlength,
    helper,
    error,
    invalid = false,
    onInput,
    onEnter,
  }: Props = $props();
</script>

<div class="space-y-1.5">
  <Label>{label}</Label>
  <TextInput
    bind:value
    {placeholder}
    {maxlength}
    invalid={invalid || !!error}
    ariaLabel={label}
    {onInput}
    {onEnter}
  />
  {#if error}
    <p class="text-xs text-red-400">{error}</p>
  {:else if helper}
    <p class="text-xs text-slate-500">{helper}</p>
  {/if}
</div>
